export enum FabricComponent {
  Main = "Main Canopy",
  MainAlternating = "Canopy Fabric, Alternating Panel",
  MainAlternatingSecond = "Canopy Fabric, Secondary Alternating Panel",
  MainAlternatingThird = "Canopy Fabric, Tertiary Alternating Panel",
  Underside = "Main Underside Canopy",
  MainTrim = "Main Canopy Trim",
  MainTrimInner = "Main Canopy Inner Trim",
  TopVent = "Top Vent",
  MiddleVent = "Middle Vent",
  MiddleAlternating = "Middle Vent, Alternating Panel",
  MiddleAlternatingSecond = "Middle Vent, Secondary Alternating Panel",
  MiddleAlternatingThird = "Middle Vent, Tertiary Alternating Panel",
  Valance = "Valance",
  ValanceAlternating = "Valance, Alternating Panel",
  ValanceAlternatingSecond = "Valance, Secondary Alternating Panel",
  ValanceAlternatingThird = "Valance, Tertiary Alternating Panel",
  VentTrim = "Vent Trim",
  Binding = "Binding",
  Pockets = "Pockets",
  FringeFirst = "Primary Fringe",
  FringeSecond = "Secondary Fringe",
  FringeThird = "Tertiary Fringe",
}
